//IMPORTANT!!!!!!
//Click the logo 10 times to unlock the amplify login screen
//needed for registering new user accounts!

//use 'yarn cypress' open to test the app

import React, { useState, useEffect,useRef  } from "react";
import "./App.css";
import Amplify, { Auth } from "aws-amplify";
import awsExports from "./aws-exports";

import { AmplifyAuthenticator } from "@aws-amplify/ui-react";
import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";

import Home from "./pages/Home";
import Login from "./pages/Login";

//redux stuff
import {useDispatch,useSelector} from 'react-redux'
import  {rxLoginUsername}  from "./features/loginUsername";
import  {rxLoginPassword}  from "./features/loginPassword";
import  {rxExhibitor}  from "./features/exhibitor";
import  {rxUser}  from "./features/user";

Amplify.configure(awsExports);

function App() {
  const [authState, setAuthState] = useState();
  //const [showAmplifyAuth, setShowAmplifyAuth] = useState(false);
  //const [loginUserName, setLoginUserName] = useState("");
  //const [loginPassword, setLoginPassword] = useState("");
  //const [exhibit, setExhibit] = useState("");
  //const [user, setUser] = useState();
  const  showAmplifyAuth= useSelector((state)=>state.auth.value);

  const qrRef = useRef(null);

  const dispatch = useDispatch();

  const handleSignOut = async () => {
    console.log("signing out");
    await Auth.signOut();
    if (qrRef.current !== null) {
      qrRef.current.stopCamera();
    }
    window.location.reload();
  };

  const handleSignIn = async (username, password) => {
    try {
      const user = await Auth.signIn(username, password);
      console.log(user);
      //Logged in so will store the values in local storage so dont get lost
      localStorage.setItem("username", username);
      localStorage.setItem("password", password);
    } catch (error) {
      if (error.hasOwnProperty('code')){
        alert("Sorry Incorrect Username/Password");
      } else if (error.indexOf("QuotaExceeded") === -1) {
        //bypass the safari error bug
        console.log("login err", error);
        alert("Sorry Incorrect Username/Password");
      }
    }
  };
  //get the json data
  useEffect(() => {
    //grab the querystring details
    let search = window.location.search;
    let params = new URLSearchParams(search);
    //setExhibit(params.get("e"));
    dispatch(rxExhibitor(params.get("e")));
    window.history.replaceState(null, null, window.location.pathname); //removes the params so cant see them
    if (params.get("u") !== null) {
      //Attempt to log in
      handleSignIn(params.get("u"), params.get("p"));
    }
    //load up the local storage if available
    if (localStorage.getItem("username") !== "") {
      //setLoginUserName(localStorage.getItem("username"));
      //setLoginPassword(localStorage.getItem("password"));
      dispatch(rxLoginUsername(localStorage.getItem("username")));
      dispatch(rxLoginPassword(localStorage.getItem("password")));
    }

    return onAuthUIStateChange((nextAuthState, authData) => {
      setAuthState(nextAuthState);
      if (authData !== undefined) {
        //setUser(authData.username);
        dispatch(rxUser(authData.username));
      }
    });
  }, [dispatch]);

  //return
  return authState === AuthState.SignedIn ? (
    <Home 
    //exhibit={exhibit} 
    //user={user}
    handleSignOut={handleSignOut}
    />
  ) : showAmplifyAuth ? (
    <AmplifyAuthenticator />
  ) : (
    <Login
    //setLoginPassword={setLoginPassword}
    //setLoginUserName={setLoginUserName}
    //loginUserName={loginUserName}
    //loginPassword={loginPassword}
    handleSignIn={handleSignIn}
    qrRef={qrRef}
    //setShowAmplifyAuth={setShowAmplifyAuth}
    //showAmplifyAuth={showAmplifyAuth}
    />
  );
}

export default App;
